import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import { Mail, Phone } from "lucide-react";
import React from "react";

type Props = {
  className?: string;
  data: Simplify<Content.FinancialSupportSliceDefaultPrimary>;
};

export default function SFDSupportCard({ data, className }: Props) {
  return (
    <Card
      className={cn(
        "shadow-none border border-transparent hover:shadow-xl hover:border-[#B4F0E5] hover:bg-[#F5FBFA] transition-all duration-300",
        className
      )}
    >
      <CardHeader>
        <CardTitle>
          <Button size="icon" className="rounded-full bg-[#EBF7FF]">
            <PrismicNextImage
              field={data.sfd_support_icon}
              alt=""
              className="size-6"
            />
          </Button>
        </CardTitle>
      </CardHeader>

      <CardContent className="text-primary space-y-4">
        <h6 className="text-3xl font-semibold">{data.sfd_support_title}</h6>

        <PrismicRichText
          field={data.sfd_support_description}
          components={{
            paragraph: ({ children }) => (
              <p className="font-merriweather leading-7">{children}</p>
            ),
          }}
        />

        <div className="flex items-center gap-2">
          <Mail />{" "}
          <span className="underline font-merriweather ">
            {data.sfd_support_email}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <Phone />{" "}
          <span className="font-merriweather ">{data.sfd_support_phone}</span>
        </div>
      </CardContent>
    </Card>
  );
}
